import { Component, OnInit, Input, ViewChild } from '@angular/core';
import * as CommonConstants from '../../utils/common.constants';
import { SharedService } from 'src/app/utils/shared.service';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import { AddTreatmentComponent } from '../treatment/add-treatment.component';
import { AddProgressComponent } from '../progress/add-progress.component';
import { AddProcedureComponent } from '../procedure/add-procedure.component';
import { AddExamsComponent } from '../exams/add-exams.component';
import { MasterService } from 'src/app/masters/master.service';

@Component({
  selector: 'app-medical-care',
  templateUrl: './medical-care.component.html',
  styleUrls: ['./medical-care.component.scss']
})
export class MedicalCareComponent implements OnInit {
  triatments=[];
  procedures=[];
  specializedExam=[];
  bilogicsExam=[];
  ImageryExam=[];
  progressess=[];
  PARAM_KEY = [CommonConstants.TREATMENT_MED_FILE, CommonConstants.PROCEDURE_MED_FILE,
  CommonConstants.PROGRESS_MED_FILE, CommonConstants.EXAMINATION_MED_FILE];
  treatment;
  procedure;
  progress;
  examType;
  
 /*  CommonConstants.BIOLOGICAL_EXAM_MED_FILE, CommonConstants.SPECIALIZED_EXAM_MED_FILE, CommonConstants.IMAGERY_EXAM_MED_FILE, */
  @Input() medFileId;

  @ViewChild(AddTreatmentComponent, { static: false }) childTreatment: AddTreatmentComponent;
  @ViewChild(AddProgressComponent, { static: false }) childProgress: AddProgressComponent;
  @ViewChild(AddProcedureComponent, { static: false }) childProcedure: AddProcedureComponent;
  @ViewChild(AddExamsComponent, { static: false }) childExams: AddExamsComponent;
  constructor(private sharedService:SharedService, private medicalFileService:MedicalFileService,
    private masterService:MasterService) { }

  ngOnInit() {
    this.masterService.getExamType().subscribe(res=>{
      if(res && res["result"]){
        this.examType = res["result"];
      }
      this.sharedService.medicalFileId$.subscribe(res =>{
        this.medFileId = res;
    /*   this.medicalFileService.getMedicalFilesByKey(this.medFileId, this.PARAM_KEY).subscribe(response=>{
        let masterValues = response['result'];
        if(masterValues){
        //   this.childTreatment.medicationtList=  this.childTreatment.setMedicationList(masterValues[CommonConstants.TREATMENT_MED_FILE])
        //  this.childProgress.prList=  this.childProgress.setProgressList(masterValues[CommonConstants.PROGRESS_MED_FILE]);
          this.childProcedure.prList = this.childProcedure.setProcedureList(masterValues[CommonConstants.PROCEDURE_MED_FILE]);
          let examMasterList = masterValues[CommonConstants.EXAMINATION_MED_FILE];
          this.childExams.specExams = this.childExams.setExamList(examMasterList.filter(item => item.cutypCode === CommonConstants.SPEC_EXAMINATION_TYPE_ID));
          this.childExams.bioExams = this.childExams.setExamList(examMasterList.filter(item => item.cutypCode === CommonConstants.BIO_EXAMINATION_TYPE_ID));
          this.childExams.imgExams = this.childExams.setExamList(examMasterList.filter(item => item.cutypCode === CommonConstants.IMG_EXAMINATION_TYPE_ID));
        }
      }) */
     })
    
    })
   
  }

}
